import React from 'react';
import PropTypes from 'prop-types';
import Translate from "../../../../components/Translate";
import BlueButton from "../../../../components-new/buttons/BlueButton";
import SilverButton from "../../../../components-new/buttons/SilverButton";

const styles = {
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    dialog: {
        backgroundColor: 'white',
        padding: '40px 20px',
        borderRadius: '10px',
        textAlign: 'center',
        maxWidth: '400px',
        width: '100%',
    },
    buttons: {
        display: 'flex',
        gap: '20px',
        marginTop: '20px',
    },
    button: {
        margin: '0 10px',
        padding: '10px 20px',
        border: 'none',
        borderRadius: '5px',
        cursor: 'pointer',
    },
    confirmButton: {
        backgroundColor: '#043e5c',
        color: 'white',
        padding: '15px 45px',
        fontSize: '16px',
        // boxShadow: 'rgba(24, 62, 153, 0.17) 2px 2px',
        borderRadius: '20px'
    },
    cancelButton: {
        backgroundColor: 'rgba(229, 229, 229, 0.35)',
        color: 'rgb(9, 24, 58)',
        padding: '15px 45px',
        fontSize: '16px',
        boxShadow: 'rgba(24, 62, 153, 0.17) 2px 2px',
        borderRadius: '20px'
    },
};

function ConfirmationDialog({isOpen, onClose, onConfirm, message}) {
    if (!isOpen) return null;

    return (
        <div style={styles.overlay}>
            <div style={styles.dialog}>
                <p>{message}</p>
                <div style={styles.buttons}>
                    <SilverButton children={<Translate text="no"/>} onClick={onClose}/>
                    <BlueButton children={<Translate text="yes"/>} onClick={onConfirm}/>
                </div>
            </div>

        </div>
    );
}

ConfirmationDialog.propTypes = {
    onClose: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
    message: PropTypes.string.isRequired,
};

export default ConfirmationDialog;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/my-history/ConfirmationDialog.jsx